import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';

import Layout from './containers/Layout';
import {
	consts as configConst,
	selectors as configuracacoesSelector
} from '../../redux/modules/configuracoes';

import { actions as userActions, selectors as userSelectors } from '../../redux/modules/usuario';
import { ROUTES } from '../../commons/routes/routes';

const DYNAMIC_REDIRECT_KEY = 'dynamicRedirectUrl';

class AppLayout extends Component {

	checkDynamicRedirect() {
		const { isAuthenticated, history } = this.props;
		if (isAuthenticated && localStorage.getItem(DYNAMIC_REDIRECT_KEY)) {
			history.push(ROUTES.OAUTH2_DYNAMIC_REDIRECT.path);
		}
	}

	componentDidMount() {
		this.checkDynamicRedirect();
	}

	render() {
		const { children, logout, isAuthenticated, isUserAdmin, token, config } = this.props;

		return (
			<Layout
				isAuthenticated={isAuthenticated}
				isUserAdmin={isUserAdmin}
				token={token}
				logout={() => logout({ exibeGovBr: config.EXIBE_BOTAO_GOV_BR_LOGIN, exibeMtLogin: config.EXIBE_BOTAO_OPENID_LOGIN })}>
				{children}
			</Layout>
		);
	}
}

function mapStateToProps(state) {
	return {
		isAuthenticated: userSelectors.isAuthenticated(state),
		isUserAdmin: userSelectors.isUserInRole(state, 'ROLE_ADMIN'),
		token: userSelectors.getUser(state).token,
		config: configuracacoesSelector.getValorConfiguracao(
			state,
			configConst.APPLICATION_CONFIG_RESOURCES
		)
	};
}

const mapDispatchToProps = {
	logout: userActions.logoutUser
};

export default compose(
	withRouter,
	connect(
		mapStateToProps,
		mapDispatchToProps
	),
	injectIntl
)(AppLayout);
